import React, {useRef, useEffect} from "react";

const Canvas = (props) => {
  const {draw, width, height} = props
  const canvasRef = useRef(null)
  
  useEffect(() => {
    const canvas = canvasRef.current
    draw(canvas)
  }, [draw])

  return (
    <canvas ref={canvasRef} height={height} width={width}/>
  )
}

export default Canvas;
